<app-shop-integration-card-list [productModel]="model" />
